@if (mode === datePanelMode.DatePreset) {
  <daui-dropdown
    [id]="id + '-date-panel'"
    class="datePreset"
    [selectedValue]="currentSelectedDatePreset.id"
    (selectionChange)="onDatePresetSelectionChange($event)"
    >
    @for (item of currentDatePreset; track item) {
      <daui-dropdown-item
        [value]="item.id"
        >{{ item.label }}</daui-dropdown-item
        >
      }
    </daui-dropdown>
  }

  @if (mode === datePanelMode.Regular) {
    <div
      class="wrapper-date-panel"
  [ngClass]="{
    small: size === datePanelSize.Small,
    medium: size === datePanelSize.Medium,
    hasDatePreset: hasDatePreset
  }"
      >
      @if (hasDatePreset && currentSelectedDatePreset) {
        <daui-dropdown
          [id]="id + '-date-panel-preset'"
          class="datePreset"
          [selectedValue]="currentSelectedDatePreset.id"
          (selectionChange)="onDatePresetSelectionChange($event)"
          >
          @for (item of currentDatePreset; track item; let index = $index) {
            @if (
              item.id !== datePresetServiceType.Today &&
              item.id !== datePresetServiceType.Custom
              ) {
              <daui-dropdown-item
                [id]="id + '-date-panel-item-' + index"
                [value]="item.id"
                >{{ item.label }}</daui-dropdown-item
                >
              }
              @if (item.id === datePresetServiceType.Today) {
                <daui-dropdown-item
                  [id]="id + '-date-panel-item-' + index"
                  [value]="item.id"
                  i18n="@@DatePresetToday"
                  >{{ 'CommonWebUI_DatePreset_Today' | translate }}</daui-dropdown-item
                  >
                }
                @if (item.id === datePresetServiceType.Custom) {
                  <daui-dropdown-item
                    [id]="id + '-date-panel-item-' + index"
                    [value]="item.id"
                    i18n="@@DatePresetCustom"
                    >{{ 'CommonWebUI_DatePreset_Custom' | translate }}</daui-dropdown-item
                    >
                  }
                }
              </daui-dropdown>
            }
            @switch (view) {
              @case (datePanelView.Day) {
                <div class="navHeader">
                  @if (hasMonth && size === datePanelSize.Small) {
                    <div
                      [id]="id + '-date-panel-month'"
                      class="month"
                      (click)="onChangeView(datePanelView.Month)"
                      >
                      {{ getNavCurrentDate('MMM') }}
                    </div>
                  }
                  @if (hasMonth && size === datePanelSize.Medium) {
                    <div
                      [id]="id + '-date-panel-month'"
                      class="month"
                      (click)="onChangeView(datePanelView.Month)"
                      >
                      {{ getNavCurrentDate('MMMM') }}
                    </div>
                  }
                  @if (hasYear) {
                    <div
                      [id]="id + '-date-panel-year'"
                      class="year"
                      (click)="onChangeView(datePanelView.Year)"
                      >
                      {{ getNavCurrentDate('YYYY') }}
                    </div>
                  }
                  <div class="navMonth">
                    @if (hasPrev) {
                      <div
                        [id]="id + '-date-panel-month-prev'"
                        (click)="changeNavMonth(-1)"
                        [ngClass]="{ disabled: !canChangeNavMonth(-1) }"
                        class="icon prev"
                      ></div>
                    }
                    @if (hasToday) {
                      <div
                        [id]="id + '-date-panel-today'"
                        class="icon today"
                        [ngClass]="{ disabled: !isTodayEnabled }"
                        (click)="onSelectToday()"
                      ></div>
                    }
                    @if (hasNext) {
                      <div
                        [id]="id + '-date-panel-month-next'"
                        (click)="changeNavMonth(1)"
                        class="icon next"
                        [ngClass]="{ disabled: !canChangeNavMonth(1), withToday: hasToday }"
                      ></div>
                    }
                  </div>
                </div>
                <div class="content">
                  <div class="weekdays">
                    @for (day of weekDaysHeaderArr; track day) {
                      <div class="day">
                        {{ day }}
                      </div>
                    }
                  </div>
                  <div class="days">
                    @for (day of days; track day) {
                      <div
                        class="date"
            [ngClass]="{
              notSelectable: !day.selectable,
              isBetween: day.isBetween === true,
              isStartDate: day.isStartDate === true,
              isEndDate: day.isEndDate === true,
              isFirstDayOfWeek: day.isFirstDayOfWeek === true,
              isLastDayOfWeek: day.isLastDayOfWeek === true,
              differentMonth: day.month !== 'current',
              selected: day.selected === true,
              fixed: day.isFixed === true,
              startEqualsEnd: day.startEqualsEnd === true
            }"
                        (click)="selectDay(day)"
                        >
                        <div
                          class="selection"
              [ngClass]="{
                today: day.isToday === true,
                selected: day.selected === true,
                fixed: day.isFixed === true,
                startEqualsEnd: day.startEqualsEnd === true && !day.isToday
              }"
                        ></div>
                        <div class="daySelected">
                          {{ day.value }}
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
              @case (datePanelView.Month) {
                <div
                  [id]="id + '-date-panel-months'"
                  class="months"
        [ngClass]="{
          small: size === datePanelSize.Small,
          medium: size === datePanelSize.Medium
        }"
                  >
                  @for (item of MonthItems; track item; let index = $index) {
                    <div
                      [id]="id + '-date-panel-months-item-' + index"
                      class="month"
          [ngClass]="{
            active: item.selected,
            disabled: !item.selectable
          }"
                      (click)="setMonth(item.value)"
                      >
                      {{ item.month }}
                    </div>
                  }
                </div>
              }
              @case (datePanelView.Year) {
                <div
                  [id]="id + '-date-panel-years'"
                  class="navYears"
        [ngClass]="{
          small: size === datePanelSize.Small,
          medium: size === datePanelSize.Medium
        }"
                  >
                  @if (hasPrev) {
                    <div
                      [id]="id + '-date-panel-year-prev'"
                      (click)="changeNavYear(-1)"
                      [ngClass]="{ disabled: !canChangeNavYear(-1) }"
                      class="icon prev"
                    ></div>
                  }
                  @if (hasToday) {
                    <div
                      [id]="id + '-date-panel-today'"
                      class="icon today"
                      (click)="onSelectTodayYear()"
                    ></div>
                  }
                  @if (hasNext) {
                    <div
                      [id]="id + '-date-panel-year-next'"
                      (click)="changeNavYear(1)"
                      class="icon next"
                      [ngClass]="{ disabled: !canChangeNavYear(1), withToday: hasToday }"
                    ></div>
                  }
                </div>
                <div class="years">
                  @for (item of YearsItems; track item; let index = $index) {
                    <div
                      [id]="id + '-date-panel-years-item-' + index"
                      class="year"
          [ngClass]="{
            active: item.selected,
            disabled: !item.selectable
          }"
                      (click)="setYears(item.value)"
                      >
                      {{ item.value }}
                    </div>
                  }
                </div>
              }
            }
          </div>
        }
